import React, { useRef } from 'react';
import Icon from 'assets/Icons';
import styled from 'styled-components';
import SendEmailCpaModal, { DataSendEmailCpaModalOpenType } from '../SendEmailCpaModal';
import { ISendEmailCpaModalRef } from '../SendEmailCpaModal';
import reportSelectors from 'features/report/services/selectors';
import reportActions from 'features/report/services/actions';
import { useAppDispatch } from 'store/hooks';

const ButtonSendEmailCpa = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
  const sendEmailCpaModalRef = useRef<ISendEmailCpaModalRef>(null);
  const payrollSelectedRowKeys = reportSelectors.getPayrollSelectedRowKeys();
  const dispatch = useAppDispatch();

  const handleClick = () => {
    const data: DataSendEmailCpaModalOpenType = {
      startDate,
      endDate,
      payrollSelectedRowKeys,
    };
    const callback = () => {
      dispatch(reportActions.setPayrollSelectedRowKeys([]));
    };
    sendEmailCpaModalRef.current?.open(data, () => {
      callback();
    });
  };
  return (
    <>
      <ButtonSendEmailCpaStyled type='button' onClick={handleClick}>
        <div className='content'>
          <div className='icon'>
            <Icon type='emailWhite' width={24} height={24} />
          </div>
          <div className='text'>Send To CPA</div>
        </div>
      </ButtonSendEmailCpaStyled>
      <SendEmailCpaModal ref={sendEmailCpaModalRef} />
    </>
  );
};

export default ButtonSendEmailCpa;

const ButtonSendEmailCpaStyled = styled.button`
  display: flex;
  height: 3.5rem;
  padding: 0px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #0da472;
  box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.4), 0 4px 8px -3px rgba(45, 35, 66, 0.3), 0 -3px 0 0 #03704c inset;
  transition: all 0.3s ease;
  .content {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &:hover {
    opacity: 0.8;
  }
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }
  .text {
    color: #fff;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
